var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M20 11a5.26 5.26 0 0 0-5.25 5.25c0 1.784.908 3.363 2.273 4.313-3.078 1.201-5.273 4.201-5.273 7.687h1.5c0-3.299 2.393-6.055 5.531-6.633L19.25 23h1.5l.469-1.383c3.138.578 5.531 3.334 5.531 6.633h1.5c0-3.486-2.195-6.486-5.273-7.687a5.26 5.26 0 0 0 2.273-4.313A5.26 5.26 0 0 0 20 11m0 1.5c2.08 0 3.75 1.67 3.75 3.75S22.08 20 20 20s-3.75-1.67-3.75-3.75S17.92 12.5 20 12.5m-.75 11.25-.75 4.5h3l-.75-4.5z"
  })));
};
export default SvgScale;